import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { dataFlowService, DataFlow, DataFlowFilters } from '../../services/dataFlowService';

interface DataFlowState {
  dataFlows: DataFlow[];
  loading: boolean;
  error: string | null;
}

const initialState: DataFlowState = {
  dataFlows: [],
  loading: false,
  error: null,
};

export const fetchDataFlows = createAsyncThunk(
  'dataFlow/fetchAll',
  async (filters: DataFlowFilters, { rejectWithValue }) => {
    try {
      return await dataFlowService.getDataFlows(filters);
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to fetch data flows');
    }
  }
);

export const exportDataFlows = createAsyncThunk(
  'dataFlow/export',
  async ({ filters, format }: { filters: DataFlowFilters; format: 'csv' | 'excel' }, { rejectWithValue }) => {
    try {
      return await dataFlowService.exportDataFlows(filters, format);
    } catch (error: any) {
      return rejectWithValue(error.response?.data?.error || 'Failed to export');
    }
  }
);

const dataFlowSlice = createSlice({
  name: 'dataFlow',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchDataFlows.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchDataFlows.fulfilled, (state, action) => {
        state.loading = false;
        state.dataFlows = action.payload as any;
      })
      .addCase(fetchDataFlows.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload as string;
      });
  },
});

export default dataFlowSlice.reducer;
